export default __webpack_public_path__ + "static/media/cgvgoodwood42.d5215bdb.pdf";